import { css } from '@landr/styled-system/css';

export const Header = css({
    position: 'absolute',
    right: 0,
    top: 0,
});

export const Content = css({
    textAlign: 'center',
    width: '100%',

    '& button, & a': {
        marginBottom: '2xl',
        width: '100%',
    },

    '& a': {
        fontWeight: 'bold',
    },
    backgroundColor: 'surface.high',
});

export const Wrapper = css({
    padding: 0,

    '& > p + button': {
        marginTop: 'sm',
    },

    width: '100%',
});

export const StyledLi = css({
    listStyle: 'outside disc',
    marginLeft: 'xl',
});
